<template>
  <div class="content-date-picker-calendar btn btn-hover btn-default">
    <i class="fa fa-calendar-o"></i>
    <span v-if="isToday">Financeiro de: Hoje</span>
    <span v-else>{{ dates.start.format("D [de] MMMM") }} - {{ dates.end.format("D [de] MMMM") }}</span>
  </div>
</template>

<script>
export default {
  props: ["dates"],
  data() {
    return {
      dateRangePicker: null
    };
  },
  methods: {
    updateDates(start, end) {
      this.dates.start = start;
      this.dates.end = end;

      this.$emit("dates-updated", this.dates);
    }
  },
  computed: {
    isToday() {
      return (
        this.dates.start.isSame(moment(), "day") &&
        this.dates.end.isSame(moment(), "day")
      );
    }
  },
  mounted() {
    let self = this;
    this.dateRangePicker = $(self.$el).daterangepicker(
      {
        startDate: this.dates.start,
        endDate: this.dates.end,
        ranges: {
          Hoje: [moment(), moment()],
          "Essa semana": [moment().startOf("week"), moment().endOf("week")],
          "Esse mês": [moment().startOf("month"), moment().endOf("month")],
          "Mês passado": [moment().subtract(1, "month").startOf("month"), moment().subtract(1, "month").endOf("month")],
          "Últimos 30 dias": [moment().subtract(29, "days"), moment()],
          "Próximos 30 dias": [moment(), moment().add(29, "days")],
          "Próximos 60 dias": [moment(), moment().add(59, "days")],
          "Próximos 90 dias": [moment(), moment().add(89, "days")]
        },
        locale: {
          cancelLabel: "Cancelar",
          applyLabel: "Aplicar",
          customRangeLabel: "Escolher período",
          daysOfWeek: ["Dom", "Seg", "Ter", "Qua", "Qui", "Sex", "Sáb"]
        }
      },
      function(start, end) {
        self.updateDates(start, end);
        self.$emit("dates-submitted");
      }
    );
  },
  watch: {
    "dates.start"() {
      this.dateRangePicker
        .data("daterangepicker")
        .setStartDate(this.dates.start);
    },
    "dates.end"() {
      this.dateRangePicker.data("daterangepicker").setEndDate(this.dates.end);
    }
  }
};
</script>
